import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Blogsidebar = ({ changeCategory, changeArchivies }) => {
    const [categories, setCategories] = useState([]);
    const [blogs, setBlogs] = useState([]);
    const [archive, setArchive] = useState([]);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await axios.post(
                    `${process.env.REACT_APP_API_URL}/get/blogs-categories`,
                    {
                        token: process.env.REACT_APP_BACKEND_TOKEN_GET
                    },
                    {
                        headers: {
                            Authorization: process.env.REACT_APP_BACKEND_TOKEN,
                        }
                    }
                );
                const categoryNames = response.data?.data?.map(item => item.Blog_category) || [];
                setCategories(categoryNames);

                const responseData = await axios.post(
                    `${process.env.REACT_APP_API_URL}/get/blogs`,
                    {
                        "limit": 3,
                        "start": 0,
                        token: process.env.REACT_APP_BACKEND_TOKEN_GET
                    },
                    {
                        headers: {
                            Authorization: process.env.REACT_APP_BACKEND_TOKEN,
                        }
                    }
                );
                setBlogs(responseData.data?.data || []);

                const responseArchive = await axios.post(
                    `${process.env.REACT_APP_API_URL}/get/archives`,
                    {
                        token: process.env.REACT_APP_BACKEND_TOKEN_GET,
                    },
                    {
                        headers: {
                            Authorization: process.env.REACT_APP_BACKEND_TOKEN,
                        }
                    }
                );

                const ArchiveDates = responseArchive.data?.data?.map(item => {
                    const date = new Date(item.Archives);
                    const month = date.toLocaleString('default', { month: 'long' });
                    const year = date.getFullYear();
                    return `${month} ${year}`;
                }) || [];

                setArchive(ArchiveDates);

            } catch (error) {
                // Error handling can be improved as needed
            }
        };

        fetchCategories();
    }, []);

    return (
        <div>
            <aside className="widget post-widget">
                <h3 className="widget-title">Recent Blogs</h3>
                <ul className="widget-post ttm-recent-post-list">
                    {blogs.map((blog, index) => {
                        const imageUrl = blog.blog_images?.[0]?.formats?.thumbnail?.url;
                        return (
                            <li key={index}>
                                {imageUrl && (
                                    <Link className="entry-title"
                                        to={{ pathname: `/${blog.URL}`, state: { doc: blog, pageName: 'blog' } }}
                                        aria-label={`Click here to read more about ${blog.title}`}
                                        title={`Read more about ${blog.title}`}
                                        >
                                        <img src={`${process.env.REACT_APP_STRAPI_URL}${imageUrl}`} alt="post-img" />
                                    </Link>
                                )}
                                <Link className="entry-title"
                                    to={{ pathname: `/${blog.URL}`, state: { doc: blog, pageName: 'blog' } }}
                                    aria-label={`Click here to read more about ${blog.title}`}
                                    title={`Read more about ${blog.title}`}
                                    >{blog.title}
                                </Link>
                                <span className="post-date">
                                    <i className="fa fa-calendar" /> {new Date(blog.created_date).toLocaleDateString('en-GB')}
                                </span>
                            </li>
                        );
                    })}
                </ul>
            </aside>
            <aside className="widget widget-categories">
                <h3 className="widget-title">Categories</h3>
                <ul className='blogCategory'>
                    {categories.map((category, index) => (
                        <li onClick={() => changeCategory(category)} key={index}>{category}</li>
                    ))}
                </ul>
            </aside>
            <aside className="widget widget-categories">
                <h3 className="widget-title">Archives</h3>
                <ul className='blogCategory'>
                    {archive.map((archivies, index) => (
                        <li onClick={() => changeArchivies(archivies)} key={index}>
                            {archivies}
                        </li>
                    ))}
                </ul>
            </aside>
        </div>
    )
}
export default Blogsidebar;